<featured-winner *ngIf="featuredWinner" [winner]="featuredWinner"></featured-winner>
